import React, { useState } from 'react'
import BtnSlider from '../slideShow2/BtnSlider'
import s from './index.module.css'

const SliderQuestionForm = props => {
  const {
    data,
    currentSlide,
    setCurrentSlide,
    setTestResult,
    testResult,
    onNextMethod = () => {},
    onPrevMethod = () => {},
  } = props

  const [optionSelected, setOptionSelected] = useState(null)
  const [slideDirection, setSlideDirection] = useState(null)
  const [selectedOptionValues, setSelectedOptionValues] = useState([])

  const nextSlide = value => {
    setSelectedOptionValues(prevSelectedOptionValue => {
      const newSlectedOptionValue = [...prevSelectedOptionValue]
      newSlectedOptionValue[currentSlide] = value
      setTestResult(prevTestResult => {
        const updatedResult =
          prevTestResult + newSlectedOptionValue[currentSlide]
        onNextMethod()
        return updatedResult
      })
      return newSlectedOptionValue
    })
    setCurrentSlide(currentSlide === data.length - 1 ? 0 : currentSlide + 1)
    setOptionSelected(null)
    setSlideDirection('questionContainerMoveLeft')
  }

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? data.length - 1 : currentSlide - 1)
    setSelectedOptionValues(prevSelectedOptionValue => {
      const newSlectedOptionValue = [...prevSelectedOptionValue]
      setTestResult(
        prevTestResult =>
          prevTestResult - newSlectedOptionValue[currentSlide - 1]
      )
      onPrevMethod()
      newSlectedOptionValue[currentSlide] = null
      return newSlectedOptionValue
    })
    setSlideDirection('questionContainerMoveRight')
  }

  const handleOptionClick = (optionIndex, option) => {
    setOptionSelected(optionIndex)
    let value = option.value
    nextSlide(value)
  }

  return (
    <>
      <div>
        {data.map((question, slideIndex) => {
          if (slideIndex === currentSlide) {
            return (
              <div
                className={`${s.containerSlider} ${slideDirection}`}
                key={question.title}
              >
                <div>
                  <h2 className={`${s.questionTitle}`}>{question.title}</h2>
                </div>
                <div>
                  {question.options.map((option, optionIndex) => (
                    <p key={option.id} className={`${s.questionOptions}`}>
                      <span
                        className={`${s.option} ${
                          optionSelected === optionIndex ? s.selected : ''
                        }`}
                        onClick={() => handleOptionClick(optionIndex, option)}
                      >
                        {option.content}
                      </span>
                    </p>
                  ))}
                </div>
                {currentSlide !== 0 && (
                  <div>
                    <BtnSlider
                      moveSlide={() => prevSlide()}
                      direction={'prev'}
                    />
                  </div>
                )}
              </div>
            )
          } else {
            return null
          }
        })}
      </div>
    </>
  )
}

export default SliderQuestionForm
